export function pagingQueryString (limit: number, offset: number) {
  const page = Math.floor(offset / limit);
  return `items_per_page=${limit}&page=${page}`;
}
